import React from 'react'
import { CheckBox } from '@clickcease/cc-client-components-lib'
import { DomainToServer } from 'Types/Domain'
import { Products } from 'Types/Product'
import { AddressCell, ProductSelectCell, TableCell } from '../NewMultipleDomains.styles'
import { SelectProducts } from './SelectProducts/SelectProducts'
import useAddDomainStore from '../store/addDomainsStore'

interface DomainTableRowProps {
  domain: DomainToServer
  handleCheckboxChange: (address: string, val: boolean) => void
  handleSetProducts: (
    address: string
  ) => (products: { paidMarketing?: boolean; botZapping?: boolean }) => void
  blockedDomains: Array<Products | undefined>
}

export const DomainTableRow = ({
  domain,
  blockedDomains,
  handleCheckboxChange,
  handleSetProducts,
}: DomainTableRowProps) => {
  const { domainsLeft } = useAddDomainStore()

  const { paidMarketing, botZapping, selected, address } = domain

  const disabled = !domainsLeft && !paidMarketing && !botZapping

  return (
    <tr>
      <TableCell>
        <CheckBox
          isChecked={!!selected}
          disabled={disabled}
          onChange={(val) => handleCheckboxChange(address, val)}
        />
      </TableCell>
      <AddressCell>{address}</AddressCell>
      <ProductSelectCell>
        <SelectProducts
          disabledProducts={blockedDomains}
          selected={{ paidMarketing: paidMarketing, botZapping: botZapping }}
          onSelect={handleSetProducts(address)}
          disabled={disabled}
        />
      </ProductSelectCell>
    </tr>
  )
}
